module.exports = __webpack_public_path__ + "img/social_icon_twitter.3d74e8bf.png";